import { useQuery } from '@tanstack/react-query'
import type { z } from 'zod'

import { httpService } from '@/api/v1/http.service'

import { schoolBreakSchema } from '../constants/school-break-schemas'
import type { SchoolBreak } from '../types'

type APIResponse = z.infer<typeof schoolBreakSchema>

const parseResponse = (response: APIResponse): SchoolBreak => ({
  id: response.id,
  name: response.name,
  status: response.status,
  startDate: response.start_date,
  endDate: response.end_date
})

export const schoolBreakQueryOptions = (breakId: string) => ({
  queryKey: ['panelSchoolBreaksRetrieve', breakId],
  staleTime: 60 * 1000,
  queryFn: async () => {
    const response = await httpService.panel.panelSchoolBreaksRetrieve(
      breakId,
      {
        fetchKeys: {
          id: true,
          name: true,
          status: true,
          start_date: true,
          end_date: true
        }
      }
    )

    return parseResponse(schoolBreakSchema.parse(response))
  }
})

export const useSchoolBreak = (breakId: string) =>
  useQuery(schoolBreakQueryOptions(breakId))
